export default __webpack_public_path__ + "static/whatsapp-2c5029c8127ee1b94a1eed09c7363673.png";